import {
    FACETED_SEARCH_RECEIVE,
    FACETED_SEARCH_TOGGLE_COMPACT,
    FACETED_SEARCH_CLOSE_COMPACT,
    FACETED_SEARCH_TOGGLE_VALUE,
    FACETED_SEARCH_SET_FILTER,
    FACETED_SEARCH_UPDATED_FACETED_FILTERS_STATE
} from '../Actions/FacetedSearch.action';

const defaultState = {
    subNavigation: [],
    sortCriteria: [],
    facetFilters: [],
    tempFacetFilters: [],
    visibleDropdownMenu: [],
    navigationTheme: 'filter',
    productsViewCachedId: null,
    tempFilterCacheId: null,
    isLoading: false
}

const allowMultipleOpenAtOnce = true;

export const facetedSearch = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FACETED_SEARCH_UPDATED_FACETED_FILTERS_STATE:
        case FACETED_SEARCH_SET_FILTER:
        case FACETED_SEARCH_RECEIVE:
            return {
                ...state,
                ...payload,
            }
        case FACETED_SEARCH_TOGGLE_VALUE:
            return {
                ...state,
                facetFilters: payload.facetFilters,
            }
        case FACETED_SEARCH_TOGGLE_COMPACT: {
            const { visibleDropdownMenu } = payload;
            let newState = [];

            if (allowMultipleOpenAtOnce) {
                newState = state.visibleDropdownMenu.includes(visibleDropdownMenu) ?
                    [...state.visibleDropdownMenu] :
                    [...state.visibleDropdownMenu, visibleDropdownMenu];
            } else {
                // Old behavior
                newState = state.visibleDropdownMenu.includes(visibleDropdownMenu) ? [] : [visibleDropdownMenu];
            }

            return {
                ...state,
                visibleDropdownMenu: newState
            }
        }
        case FACETED_SEARCH_CLOSE_COMPACT: {
            const { visibleDropdownMenu } = payload;

            const newState = [...state.visibleDropdownMenu];
            const indexToRemove = state.visibleDropdownMenu.indexOf(visibleDropdownMenu);
            if (indexToRemove > -1) {
                newState.splice(indexToRemove, 1);
            }

            return {
                ...state,
                visibleDropdownMenu: newState
            }
        }
        default:
            return state;
    }
}
